import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider, DialogProvider } from './components/ui';
import './index.css';

// Set global base URL so all axios.get('/api/...') calls route to the API server in production
const apiUrl = process.env.REACT_APP_API_URL || '';
if (apiUrl) {
  axios.defaults.baseURL = apiUrl.replace(/\/api$/, '');
}

// Load the configured currency symbol (cached in localStorage, so no flicker
// after the first visit). Must run after baseURL is set.
const { initCurrency } = require('./utils/currency');
initCurrency();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ToastProvider>
      <DialogProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </DialogProvider>
    </ToastProvider>
  </React.StrictMode>
);
